import * as React from 'react';
import {
    FormGroup,
    ControlLabel,
    InputGroup,
    Button,
    ButtonToolbar,
    FormControl,
    Table
} from 'react-bootstrap';
import ICoordinate from '../ICoordinate';

export class Circle {
    private circle: google.maps.Circle;
    public Center: ICoordinate;
    public Radius: number;
    public Draggable: boolean;
    public Visible: boolean;
    public Editable: boolean;
    private onChange: (center: ICoordinate, radius: number) => void;

    constructor(
        center: ICoordinate,
        radius: number,
        draggable: boolean,
        editable: boolean,
        visible: boolean,
        onChange: (center: ICoordinate, radius: number) => void
    ) {
        this.Center = center;
        this.Radius = radius;
        this.Draggable = draggable;
        this.Visible = visible;
        this.Editable = editable;
        this.onChange = onChange;
    }

    redraw(map: google.maps.Map): void {
        if (this.circle) {
            this.circle.setMap(null);
            this.circle.setMap(map);
        }
    }

    setProperties(center: ICoordinate, radius: number) {
        if (this.circle) {
            this.circle.setCenter({
                lat: center.latitude,
                lng: center.longitude
            });
            this.circle.setRadius(radius);
        }
    }

    setVisible(visible: boolean) {
        if (this.circle) {
            this.circle.setVisible(visible);
        }
    }

    hideIfIntersects(coordinate: ICoordinate) {
        if (!this.Center || !this.Radius) return;
        let latLng = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
        let circle = this.circle;
        if (!circle) {
            circle = new google.maps.Circle({
                center: new google.maps.LatLng(this.Center.latitude, this.Center.longitude),
                radius: this.Radius
            });
        }

        this.Visible =
            circle.getBounds().contains(latLng) &&
            google.maps.geometry.spherical.computeDistanceBetween(circle.getCenter(), latLng) <=
                circle.getRadius();
    }

    createCircle(map: google.maps.Map, highlight: boolean, handleClick: () => void) {
        if (!this.Visible || !this.Center || !this.Radius) return;

        let center = this.Center
            ? new google.maps.LatLng(this.Center.latitude, this.Center.longitude)
            : map.getCenter();
        this.circle = new google.maps.Circle({
            map: map,
            strokeColor: highlight ? '#FF0000' : '#0035ff',
            strokeOpacity: 0.4,
            strokeWeight: highlight ? 2 : 1,
            fillColor: highlight ? '#FF0000' : '#0035FF',
            fillOpacity: highlight ? 0.25 : 0.1,
            draggable: this.Draggable,
            editable: this.Editable,
            visible: this.Visible,
            radius: this.Radius,
            center: center,
            zIndex: highlight ? 500 : null
        });
        let eventHandler = () => {
            this.Center = {
                latitude: this.circle.getCenter().lat(),
                longitude: this.circle.getCenter().lng()
            };

            this.Radius = this.circle.getRadius();
            this.onChange(this.Center, this.Radius);
        };

        if (handleClick) {
            this.circle.addListener('click', handleClick);
        }

        this.circle.addListener('radius_changed', eventHandler);
        this.circle.addListener('center_changed', eventHandler);
    }
}

export default Circle;
